export default (that) => [
  {
    text: that.$l('btn_label_info_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_label_info_edit') || '编辑标准',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ dfDefinitionStatus }) => !['N'].includes(dfDefinitionStatus),
  },
  {
    text: that.$l('btn_label_info_delete') || '删除标准',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    disabled: ({ dfDefinitionStatus }) => !['N', 'S'].includes(dfDefinitionStatus),
  },
  {
    text: that.$l('btn_label_info_enable') || '标准启用',
    icon: 'el-icon-check',
    menuType: 'enable',
    divided: true,
    allow: 'E',
    disabled: ({ dfDefinitionStatus }) => !['N', 'S'].includes(dfDefinitionStatus),
  },
  {
    text: that.$l('btn_label_info_disableData') || '停用标准',
    icon: 'el-icon-circle-close',
    menuType: 'disableData',
    divided: false,
    allow: 'S',
    disabled: ({ dfDefinitionStatus }) => !['N', 'Y'].includes(dfDefinitionStatus),
  },
  {
    text: that.$l('btn_label_info_copy') || '复制标准',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    divided: true,
    allow: 'C',
    disabled: ({ dfDefinitionStatus }) => ['D'].includes(dfDefinitionStatus),
  },
]
